import { render } from "./StepQuoteConfirm.vue?vue&type=template&id=8e015044"
import script from "./StepQuoteConfirm.vue?vue&type=script&lang=js"
export * from "./StepQuoteConfirm.vue?vue&type=script&lang=js"

import "./StepQuoteConfirm.vue?vue&type=style&index=0&id=8e015044&lang=css"

import exportComponent from "/home/marwin/projects/123parebrise/appointment-module/src-js/frontend-shortcode-appointment-module/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__